import styled from '@emotion/styled';

export const ForecastTricastTitle = styled('span', { label: 'ForecastTricastTitle' })`
    position: relative;
    font-size: 20px;
    border-left: 1px solid #dbe1de;
    border-right: 1px solid #dbe1dc;
    margin-right: -1px;
    white-space: nowrap;
    height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
